// extracted by mini-css-extract-plugin
export var card = "_oi-0";
export var content = "_oi-2";
export var details = "_oi-3";
export var icon = "_oi-1";
export var iconBlue = "_oi-5";
export var iconBrand = "_oi-4";
export var iconGrayBlue = "_oi-6";
export var iconGreen = "_oi-7";
export var iconIndigo = "_oi-8";
export var iconOrange = "_oi-9";
export var iconPurple = "_oi-a";
export var iconRed = "_oi-b";
export var iconWarning = "_oi-c";